export default "__VITE_ASSET__6410b452__"